import React from "react";
export function useToggle(initialValue = false) : [boolean, (v?:boolean) => void] {
    const [value, setValue] = React.useState(initialValue);
    const toggle = React.useCallback((explicitSet? : boolean) => {
        if(explicitSet !== undefined) setValue(explicitSet);
        else setValue((value) => !value);
    }, []);
    return [value, toggle];
}